import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
  Update,
} from '@reduxjs/toolkit'
import {
  bulkEnableDisable,
  getAllRules,
  removeAssignmentRule,
  toggleAssignmentRulePause,
  updateAssignmentRule,
} from '.'

import { StoreData } from '../reducers/typings'
import { createAssignmentRule } from './api'
import { AssignmentRuleDTO } from './typings'

const assignmentRulesAdapter = createEntityAdapter<AssignmentRuleDTO>({
  sortComparer: (a, b) => {
    return a.order - b.order
  },
})

export const initialState = assignmentRulesAdapter.getInitialState()
const assignmentRulesSlice = createSlice({
  name: 'assignmentRulesSlice',
  initialState: initialState,
  reducers: {
    setAssignmentRulesOrder: (
      state,
      { payload }: PayloadAction<AssignmentRuleDTO[]>,
    ) => {
      const update: Update<AssignmentRuleDTO>[] = payload.map((s) => ({
        id: s.id,
        changes: { order: s.order },
      }))
      assignmentRulesAdapter.updateMany(state, update)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllRules.fulfilled, (state, { payload }) => {
      assignmentRulesAdapter.setAll(state, payload)
    })
    builder.addCase(createAssignmentRule.fulfilled, (state, { payload }) => {
      assignmentRulesAdapter.addOne(state, payload)
    })
    builder.addCase(updateAssignmentRule.fulfilled, (state, { payload }) => {
      assignmentRulesAdapter.setOne(state, payload)
    })
    builder.addCase(removeAssignmentRule.fulfilled, (state, { payload }) => {
      assignmentRulesAdapter.removeOne(state, payload)
    })
    builder.addCase(
      toggleAssignmentRulePause.fulfilled,
      (state, { payload }) => {
        assignmentRulesAdapter.updateOne(state, {
          id: payload.id,
          changes: { enabled: payload.toggleState },
        })
      },
    )
    builder.addCase(bulkEnableDisable.fulfilled, (state, { payload }) => {
      const updates = state.ids.map((id) => ({
        id,
        changes: { enabled: payload },
      }))

      assignmentRulesAdapter.updateMany(state, updates)
    })
  },
})

export const { setAssignmentRulesOrder } = assignmentRulesSlice.actions

export default assignmentRulesSlice.reducer

export const { selectAll: selectAllAssignmentRules } =
  assignmentRulesAdapter.getSelectors<StoreData>(
    (state) => state.assignmentRules,
  )
